<template>
  <div ref="container">
    <div class="coupon-list" v-if="vipList.length > 0">
      <h1>购买会员</h1>
      <div
        class="item acea-row row-center-wrapper"
        v-for="(item, index) in vipList"
        :key="index"
      >
        <div class="money" :style="'background-image:url('+item.image+')'">
<!--          <span class="num">{{ item.coupon_price }}</span>-->
        </div>
        <div class="text">
          <div class="condition line1">
            {{item.name}}
          </div>
          <div class="data acea-row row-between-wrapper" style="height: 15px;overflow: hidden;width: 200px;">
            购物优惠：{{ item.discount }}折
          </div>
          <div @click="showEx(index)" style="height: 15px;overflow: hidden;width: 200px;white-space: nowrap;text-overflow: ellipsis;font-size: 0.2rem;
    color: #999;">
            {{item.explain}} {{item.gift_label}}
          </div>
          <div class="data acea-row row-between-wrapper">
            <div v-if="item.is_forever == 0">
              有效期：{{ item.valid_date }}天
            </div>
            <div v-else>有效期：永久</div>
            <div class="bnt bg-color-red" @click="buyVip(item)">
              <span v-if="item.money > 0">￥{{item.money}} 购买</span>
              <span v-else>免费</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getVip, buyVip, getOrderStatus } from "@api/user";
import { Dialog,Toast } from 'vant';
import { pay } from "@libs/wechat";
import { isWeixin } from "@utils";

export default {
  name: "buyVip",
  props: {},
  data: function() {
    return {
      page: 1,
      limit: 10,
      vipList: [],
      pay_type: isWeixin() ? "weixin" : "ysf"
    };
  },
  mounted: function() {
    this.getVips();
  },
  methods: {
    // 跳转到福袋优惠券展示页面
    toShowFd: function(level) {
      if (level.cid.length > 0) this.$router.replace({ name: "couponFd",query:{id: level.id} });
    },
    buyVip: function(level) {
      let that = this;
      let levelId = level.id
      // 购买vip
      buyVip({levelId:levelId,pay_type:that.pay_type})
        .then(res => {
          if ("ysf" === that.pay_type) {
            if (res.data.transNo === "free") {
              Toast("开通成功");
              that.toShowFd(level)
            } else {
              upsdk.pluginReady(function() {
                upsdk.pay({
                  tn: res.data.transNo,
                  success: function() {
                    let num = 0;
                    const interval = setInterval(() => {
                      if (num < 100) {
                        getOrderStatus({
                          orderId: res.data.orderId
                        }).then(response => {
                          num++;
                          if (response.data.result === 1) {
                            Toast("支付成功");
                            clearInterval(interval);
                            that.toShowFd(level)
                          }
                        });
                      } else {
                        clearInterval(interval);
                      }
                    }, 500);
                    Dialog.confirm({
                      title: '提示',
                      message: '确认支付结果？',
                      confirmButtonText: '已支付',
                      cancelButtonText: '已取消'
                    }).then(() => {
                      getOrderStatus({
                        orderId: res.data.orderId
                      }).then(response => {
                        if (response.data.result === 1) {
                          Toast("支付成功");
                          clearInterval(interval);
                          that.toShowFd(level)
                        }
                      });
                    }).catch(() => {
                      clearInterval(interval);
                      Toast("已取消");
                    })
                  },
                  fail: function(err) {
                    console.log(err);
                    Toast("取消支付");
                  }
                });
              });
            }
          } else {
            var data = res.data;
            if (data.data === "free") {
              Toast("开通成功");
              that.toShowFd(level)
            } else {
              pay(data.data).finally(() => {
                Toast("支付成功");
                that.toShowFd(level)
              }).catch(function() {
                Toast("支付失败");
              });
            }
          }
        })
        .catch(res => {
          Toast(res.msg);
        });
    },
    getVips: function() {
      let that = this;
      if (that.loading) return; //阻止下次请求（false可以进行请求）；
      if (that.loadend) return; //阻止结束当前请求（false可以进行请求）；
      that.loading = true;
      getVip().then(res => {
        that.loading = false;
        that.vipList = res.data;
      });
    },
    showEx: function(index) {
      Dialog.alert({
        title: this.vipList[index].name,
        message: this.vipList[index].explain,
      })
    }
  }
};
</script>
<style type="text/css">
.van-dialog__message{
  text-align: left;
}
</style>
